import {
  DefaultModalDialog,
  useToast,
} from '~/common/components/defaultUIComponents';
import WorkingInfoApi from '~/common/api/zeiterfassungServerApi/WorkingInfoApi';
import { DateInput } from '~/common/components/defaultUIComponents/DateInput';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { formatName } from '~/common/utils/employeeUtils';
import * as dateFns from 'date-fns';
import * as yup from 'yup';
import React from 'react';

type Props = {
  employee: Employee;
  isOpen: boolean;
  onToggle: () => void;
};

export const AddDateModal: React.FC<Props> = ({
  employee,
  isOpen,
  onToggle,
}) => {
  const toast = useToast({
    status: 'error',
  });
  const { mutateAsync: addDate } = WorkingInfoApi.hooks.useAddDate();
  return (
    <DefaultModalDialog
      dialogHeaderText="createDate.header"
      headerParams={[formatName(employee)]}
      submitText="createDate.submit"
      isOpen={isOpen}
      showCancelButton
      onCancel={onToggle}
      onSubmit={(values: { date: string }) => {
        return addDate({
          employee,
          date: dateFns.parse(values.date, 'yyyy-MM-dd', new Date()),
        })
          .catch(({ status }) => {
            if (status === 409) {
              toast({
                title: 'createDate.failed.title',
                description: 'createDate.failed.reason',
                descriptionParams: [
                  dateFns.format(
                    dateFns.parse(values.date, 'yyyy-MM-dd', new Date()),
                    'dd.MM.yyyy',
                  ),
                  formatName(employee),
                ],
              });
            }
          })
          .then(onToggle);
      }}
      initialValues={{
        date: dateFns.format(new Date(), 'yyyy-MM-dd'),
      }}
      validateOnChange
      validationSchema={yup.object().shape({
        date: yup
          .date()
          .required()
          .transform((_, originalValue) =>
            dateFns.isDate(originalValue)
              ? (originalValue as Date)
              : dateFns.parse(
                  originalValue as string,
                  'yyyy-MM-dd',
                  new Date(),
                ),
          ),
      })}
      isInitialValid={false}
    >
      <DateInput
        w="full"
        name="date"
        useInFormik
        label="createDate.date"
        labelAlign="start"
      />
    </DefaultModalDialog>
  );
};
